
import { Button } from "@/components/ui/button";
import { ComplaintType } from "./ComplaintTypeSelector";
import { useTextColorClass } from "@/components/ui/text-coloring";
import { useIsMobile } from "@/hooks/use-mobile";

interface ComplaintTypeCardProps {
  type: ComplaintType;
  onSelect: (type: ComplaintType) => void;
}

export const ComplaintTypeCard = ({ type, onSelect }: ComplaintTypeCardProps) => {
  const { baseText, subtleText, isDark } = useTextColorClass();
  const isMobile = useIsMobile();

  return (
    <Button
      variant="ghostNoHover"
      className={`flex flex-col bg-card border items-center space-y-1 hover:scale-105 active:scale-95 transition-all w-full h-full py-4 break-words`}
      onClick={() => onSelect(type)}
    >
      <div className="text-accent flex-shrink-0">{type.icon}</div>
      <span>{type.label}</span>
      <span className={`sm:text-xs whitespace-normal`}>
        {type.description}
      </span>
    </Button>
  );
};
